import { MouseEvent, ReactNode } from 'react';

import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import EditIcon from '@mui/icons-material/Edit';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { bindMenu, bindTrigger, usePopupState } from 'material-ui-popup-state/hooks';

type Props = {
  popupId: string;
  editLabel: string;
  deleteLabel: string;
  optionsAriaLabel: string;
  onEdit: (e?: MouseEvent<unknown>) => void;
  onDelete: (e?: MouseEvent<unknown>) => void;
  trailing?: ReactNode;
};

export default function TicketCardEditDeleteFooter({
  popupId,
  editLabel,
  deleteLabel,
  optionsAriaLabel,
  onEdit,
  onDelete,
  trailing,
}: Props) {
  const toolsMenu = usePopupState({ variant: 'popover', popupId });

  return (
    <>
      <IconButton {...bindTrigger(toolsMenu)} aria-label={optionsAriaLabel} size="small">
        <MoreVertIcon />
      </IconButton>
      <Menu {...bindMenu(toolsMenu)}>
        <MenuItem
          onClick={e => {
            onEdit(e);
            toolsMenu.close();
          }}
        >
          <ListItemIcon>
            <EditIcon color="primary" fontSize="small" />
          </ListItemIcon>
          <ListItemText>{editLabel}</ListItemText>
        </MenuItem>
        <MenuItem
          onClick={e => {
            onDelete(e);
            toolsMenu.close();
          }}
        >
          <ListItemIcon>
            <DeleteForeverIcon color="error" fontSize="small" />
          </ListItemIcon>
          <ListItemText>{deleteLabel}</ListItemText>
        </MenuItem>
      </Menu>
      {trailing ? (
        <>
          <Box sx={{ flex: 1 }} />
          {trailing}
        </>
      ) : null}
    </>
  );
}
